import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers'
import CircularProgress from '@mui/material/CircularProgress'
import { Suspense } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactQueryDevtools } from 'react-query/devtools'

import { I18nProvider } from 'contexts/I18nContext'
import { ReactQueryProvider } from 'providers/ReactQueryProvider'
import StylesProvider from 'providers/StylesProvider'
import SnackbarProvider from 'providers/SnackbarProvider'

import { AppProviderProps } from './index'

const AppProvider = ({ children }: AppProviderProps) => {
  const fallback = (
    <div style={{ alignSelf: 'center', width: '100%', textAlign: 'center' }}>
      <CircularProgress />
    </div>
  )
  return (
    <StylesProvider>
      <Suspense fallback={fallback}>
        <I18nProvider>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Router>
              <SnackbarProvider>
                <QueryParamProvider ReactRouterRoute={Route}>
                  <ReactQueryProvider>
                    <>
                      <ReactQueryDevtools initialIsOpen={false} />
                      {children}
                    </>
                  </ReactQueryProvider>
                </QueryParamProvider>
              </SnackbarProvider>
            </Router>
          </LocalizationProvider>
        </I18nProvider>
      </Suspense>
    </StylesProvider>
  )
}

export default AppProvider
